'use strict';

angular.module('navbar', ['dudeAuth', 'dudeControlsShell', 'translate', 'dudeLog']);

'use strict';

angular.module('navbar')
    .controller('NavbarController', function ($rootScope, $translate, authService) {
        var self = this;
        var userName = '';

        self.title = {
            text: $translate.instant('navBar.title'),
            routerPath: 'secure.interceptor'
        };

        self.support = {
            phoneText: $translate.instant('helpDropdown.phone.phoneDisplay'),
            phoneHref: $translate.instant('helpDropdown.phone.phoneHref'),
            emailTitle: $translate.instant('helpDropdown.email.title'),
            emailAddress: $translate.instant('helpDropdown.email.address'),
            liveChat: true
        };

        self.logout = function (event) {
            event.preventDefault();
            authService.logout();
        };

        var createNavigationArray = function () {
            self.navigationArray = [
                {
                    name: $translate.instant('navBar.userSettings'),
                    icon: 'fa-user',
                    hasPermission: true,
                    type: 'iconMenu',
                    accordion: [
                        {
                            name: userName,
                            type: 'text',
                            hasPermission: true
                        },
                        {
                            name: 'divider',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.logout'),
                            clickFunction: self.logout,
                            icon: 'fa-sign-out',
                            hasPermission: true
                        }
                    ]
                }
            ];
        };

        authService.getContext().then(function (data) {
            self.profile = data;
            self.title.subText = data.account.name;

            self.support.accountNumber = data.account.number;

            self.support.profile = data;

            userName = data.user.firstName + ' ' + data.user.lastName;
            createNavigationArray();
        });
    });

'use strict';

angular.module('home', ['ui.router', 'dudeAuth', 'translate']);

'use strict';

angular.module('home')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.home', {
                url: 'home',
                templateUrl: 'app/components/home/home.html',
                controller: 'HomeController',
                controllerAs: 'home',
                resolve: {
                    myProducts: function (DudeApi) {
                        return DudeApi.MyProductsEntity.query().$promise;
                    }
                }
            });
    });

'use strict';

angular.module('home')
    .controller('HomeController', function (myProducts) {
        var self = this;
        self.listOfProducts = myProducts.data.filter(function (data) {
            return data.name !== 'Dude Portal';
        });
    });

'use strict';

angular.module('helpers', []);

'use strict';

angular.module('helpers')
    .constant('permission', {
        users: {
            create: 'Users-Create',
            read: 'Users-Read',
            update: 'Users-Update'
        },
        accounts: {
            create: 'Accounts-Create',
            read: 'Accounts-Read',
            update: 'Accounts-Update',
            delete: 'Accounts-Delete'
        }
    });

'use strict';

angular.module('dudePortal', [
    // need these 2 for global configuration see. index.config.js
    'ui.router',
    'pascalprecht.translate',
    'ngSanitize',
    'spinner',

    // DudeBase/DudeControls Global Modules
    'notification', // Toastr
    'dudeError', // DudeBase
    'utils',
    'updateLanguage',

    // Application
    'dudeErrorPages',
    'navbar',
    'helpers',
    'home'
]);

'use strict';

angular.module('dudePortal')
    .controller('IndexController', function ($scope) {
        var self = this;

        // This Keeps the navbar and footer from prematurely loading before the user context.
        self.userContextLoaded = false;

        $scope.$on('dudeAuth:user-loaded', function () {
            self.userContextLoaded = true;
        });
    });

'use strict';

angular.module('dudePortal')
    .constant('appConfig', {
        api: {
            // TODO Change this list as necessary.
            core: /* DudeApiUri */ 'http://vnext.api.localtest.me' /* DudeApiUri */,
            security: /* DudeOauthUri */ 'http://login.localtest.me' /* DudeOauthUri */,
            file: /* DudeFileUri */ 'http://vnext.file.localtest.me' /* DudeFileUri */,
            report: /* DudeFileUri */ 'http://vnext.report.localtest.me' /* DudeFileUri */
        },
        analytics: {
            pendo: {
                apiKey: /* PendoApiKey */ '' /* PendoApiKey */,
                productName: /* PendoProductName */ '' /* PendoProductName */
            }
        },
        settings: {
            // TODO Update this to your app name followed by 'publicclient';
            // all-lower-case, no-spaces. This should be added to the automation
            // (setup.js) at some point.
            clientId: 'dudeportalpublicclient'
        }
    })
    .config(function ($urlRouterProvider, $translateProvider, appConfig, dudeApiConfigProvider, loginRedirectorProvider) {
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy(null);
        loginRedirectorProvider.clientId = appConfig.settings.clientId;

        $urlRouterProvider.otherwise(function ($injector, $location) {
            var path = $location.path();
            // Stops the loop-de loop
            if (path === '/' || path === '') {
                $injector.get('$state').transitionTo('secure.home');
            }
        });

        // set urls
        // TODO Change these as necessary. This list should match the one above in the appConfig.api block.
        dudeApiConfigProvider.baseUrl = appConfig.api.core;
        dudeApiConfigProvider.securityUrl = appConfig.api.security;
        dudeApiConfigProvider.fileUrl = appConfig.api.file;
        dudeApiConfigProvider.reportUrl = appConfig.api.report;
    })
    .run(function ($rootScope, $log, $window, notification, marketizr, dudeGuid, appConfig) {
        // Configure the notifications service
        // for toastr messages
        notification.init();

        // Listen for the user context to load and create a base remote logger object
        // This will be used to send info to new relic
        var baseLogObj = {};
        $rootScope.$on('dudeAuth:user-loaded', function (event, data) {
            baseLogObj = {
                accountDbId: data.account.id,  // accountId breaks new relic
                accountNumber: data.account.number,
                accountName: data.account.name,
                asset: data.account.assets || 'MaintenanceMVP',
                userId: data.user.id,
                userEmail: data.user.email
            };
        });

        // setup listener for `remote` errors that need to be logged to new relic
        $rootScope.$on('dudeLog:remote', function (event, data) {
            if ($window.newrelic) {
                // Check if data coming in is not an object and convert it
                if (!angular.isObject(data)) {
                    data = {
                        message: data
                    };
                }
                // Generate a guid
                baseLogObj.dudeReferenceId = dudeGuid.generate();
                var actionData = angular.extend(baseLogObj, data);
                $window.newrelic.addPageAction('DudeError', actionData);
            }
        });

        $rootScope.$on('$stateChangeSuccess', function () {
            $window.document.body.scrollTop = $window.document.documentElement.scrollTop = 0;
        });

        $rootScope.$on('$stateChangeError', function () {
            $log.log(arguments);
        });

        $rootScope.analytics = appConfig.analytics;
    });

angular.module("translations", []).config(["$translateProvider", function($translateProvider) {
$translateProvider.translations("en", {
    "home": {
        "home": "Home",
        "title": "Applications"
    }
}
);

$translateProvider.translations("en", {
    "TODO": "Get rid of this to do item and change the text below as appropriate to match your new application",
    "navBar": {
        "title": "Dude Portal",
        "product": "MaintenanceMVP",
        "mainNav": "Main Navigation",
        "toggleNav": "Toggle Navigation",
        "accountSettings": "Account Settings",
        "WOID": "Work Order ID",
        "assetTypes": "Asset Types",
        "invalidId": "Invalid Work Order Id",
        "configurations": "Configurations",
        "userSettings": "User Settings",
        "editProfile": "Edit Profile",
        "changePassword": "Change Password",
        "notificationSettings": "Notification Settings",
        "logout": "Logout",
        "requester": {
            "workOrders": "My Requests",
            "newWorkOrder": "New Request"
        }
    },
    "helpDropdown": {
        "email": {
            "title": "mailto:support@dudesolutions.com?subject=MaintenanceMVP",
            "address": "support@dudesolutions.com"
        },
        "phone": {
            "phoneDisplay": "1-877-655-DUDE (3833)",
            "phoneHref": "tel:18776553833"
        }
    }
}
);

$translateProvider.translations("en", {
    "general": {
        "filters": "Filters",
        "sort": "Sort",
        "all": "All",
        "result": "Result",
        "results": "Results",
        "noResults": "No Results",
        "actionsText": "Actions",
        "edit": "Edit",
        "refineBy": "Refine By",
        "viewDetails": "View Details",
        "inactive": "Inactive",
        "required": "Required",
        "search": "Search",
        "close": "Close",
        "selectAll": "Select All",
        "unselectAll": "Unselect All",
        "clearAll": "Clear All",
        "disabled": "Disabled",
        "notActivated": "Not Activated",
        "at": "at",
        "actions": {
            "new": "New",
            "add": "Add",
            "save": "Save",
            "saveAndNext": "Save & Next",
            "saveAndEdit": "Save & Keep Editing",
            "saveAndFinish": "Save & Finish",
            "delete": "Delete",
            "cancel": "Cancel",
            "close": "Close",
            "ok": "Ok",
            "yes": "Yes",
            "no": "No",
            "back": "Back"
        },
        "validation": {
            "required": "Required",
            "email": "Invalid Email",
            "emailAlreadyExists": "Email address already exists",
            "timeEmpty": "Please enter a time"
        },
        "abbreviations": {
            "hours": "hrs",
            "hour": "hr"
        }
    }
}
);
}]);

'use strict';

// The dependencies for translate must be declared in this order or translations will fail in testing declaring $translateProvider undefined.
// So the angular translate dependency 'pascalprecht.translate' must be declared first.
angular.module('translate', ['pascalprecht.translate', 'translations']);

angular.module("dudePortal").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/home/home.html","<div class=\"row header-container\"><div class=col-xs-12><h4>{{::\'home.title\' | translate}}</h4></div></div><div class=\"main-container home\"><div class=content-section><ul class=\"list-unstyled list-inline\"><li ng-repeat=\"product in home.listOfProducts\" track by $index><a class=\"btn btn-default btn-lg\" ng-href={{product.url}}>{{product.displayName}}</a></li></ul></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<div ng-controller=\"NavbarController as navBar\"><dude-navigation navigation-title=navBar.title help-menu=navBar.support navigation=navBar.navigationArray></dude-navigation></div>");}]);